import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { DEFAULT_AVIA_TAG_FILTERS } from "../../variables/apiTags"

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/",
  credentials: "include",
  prepareHeaders: (headers) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    if (csrfToken) {
      headers.set("X-CSRF-Token", csrfToken)
    }
    return headers
  },
})

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: rawBaseQuery,
  endpoints: () => ({}),
  tagTypes: ["BundleColumns", "ColumnTemplates"],
  refetchOnFocus: false,
})

export default baseApi
